var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { media } from '../themes/theme';
import { FocusStylesInverted } from '../../styles/FocusStyles';
import useHasReactRouterContext from '../../hooks/useHasReactRouterContext';
import { isAbsoluteLink } from '../utils/isAbsoluteLink';
const NavLinkCss = css `
  color: ${props => props.theme.White};
  text-decoration: none;
  position: relative;
  margin-bottom: 1rem;
  display: inline-block;
  font-size: 1rem;

  ::after {
    content: '';
    z-index: 2;
    display: ${props => (props.isActive ? 'block' : 'none')};
    background: ${props => props.theme.BrandPrimary};
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0.125rem;
  }

  ${media.laptop `
    padding-bottom: 0.625rem;
    padding-top: 0.625rem;
    margin-top: -0.625rem;
    margin-bottom: 0;
    font-size: .875rem;
  `}

  ${FocusStylesInverted}
`;
const NavLink = styled((_a) => {
    var { isActive, to, onClick } = _a, rest = __rest(_a, ["isActive", "to", "onClick"]);
    const hasReactRouterContext = useHasReactRouterContext();
    return isAbsoluteLink(to) || !hasReactRouterContext ? (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    React.createElement("a", Object.assign({ href: to, onClick: onClick }, rest))) : (React.createElement(Link, Object.assign({ to: to, onClick: onClick }, rest)));
}) `
  ${NavLinkCss}
`;
export const FooterMetaNavigationItem = ({ children, to, className = undefined, isActive = false, dataTestId = undefined, onClick = undefined, }) => (React.createElement(NavLink, { to: to, className: className, isActive: isActive, "data-testid": dataTestId, onClick: onClick }, children));
